import { render, staticRenderFns } from "./_NormalSearchNav377.vue?vue&type=template&id=20ce5c94&scoped=true"
import script from "./_NormalSearchNav377.vue?vue&type=script&lang=js"
export * from "./_NormalSearchNav377.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce5c94",
  null
  
)

export default component.exports